// This version of jwplayer will automatically inject itself to the window object upon importation
import '@viddsee/jwplayer';

// Key setup will be done here before jwplayer is being exported out for usage
window.jwplayer.key = '4tCD5aTLxsYA1BcIZtRHel3tqILpij3zESZpJA==';
export default window.jwplayer;
